import { KnownOrderDtoStatus, OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { createPath, Paths } from '../../../../app/router/app.router';
import { Order } from '../../../../ui/components/pure/icons/Order.icon';
import { orderStatusBackgroundColors } from '../../orders.constants';
import { getOrderStatusLabelForProject } from '../../../../core/util/status-label.util';
import { makeDefineOrderDetailsActions, OrderDetailsActions } from '../actions/order-details.actions';
import { WorkflowCardProps } from '../../../../ui/components/pure/workflow-card/workflow-card.component';
import { WorkflowDetailsHeaderProps } from '../../../../ui/components/pure/workflow-details-header/workflow-details-header.component';
import { BookingFlowType } from '../../../../ui/enums/booking-flow-type.enum';

export function makeOrderDetailsHeaderProps(
  projectID: string,
  order: OrderDto,
  setAction: (action: OrderDetailsActions) => void,
  bookingFlowType: BookingFlowType
): WorkflowDetailsHeaderProps {
  return {
    workflowType: 'Order',
    WorkflowIcon: Order,
    workflowStatus: getOrderStatusLabelForProject(order.status as KnownOrderDtoStatus, bookingFlowType),
    bgColor: orderStatusBackgroundColors[order.status as KnownOrderDtoStatus],
    workflowReference: order.orderNumber,
    actions: makeDefineOrderDetailsActions(order, projectID, bookingFlowType)(setAction),
    isDeleted: order.isDeleted
  };
}

export function makeOrderDetailsCardProps(order: OrderDto): WorkflowCardProps {
  return {
    // Retailers can book orders without a recipient
    recipientName: order.customer?.displayName ?? 'Unknown',
    recipientLink: order.customer
      ? createPath(Paths.customer, { projectID: order.retailer.id, userID: order.customer.id })
      : undefined,
    recipientLabel: 'CUSTOMER',
    deliveredByName: order.retailer.name,
    deliveredByIconSrc: order.retailer.imageURL,
    deliveredByLabel: 'RETAILER'
  };
}
